import TermsAndCondition from "../components/itinerary/TermsAndCondition";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileHeader from "../components/MobileHeader";
import FloatingActionButton from "../components/home/FloatingActionButton";

const Terms = () => {
    return (
        <>
            <div className="d-none d-lg-block">
                <Header />
            </div>
            <MobileHeader />
            <div className="container my-5">
                <TermsAndCondition />
            </div>
            <FloatingActionButton />
            <Footer />
        </>
    );
}

export default Terms;